module.exports = __webpack_public_path__ + "static/media/sasdatabase.59255c3b.svg";